/**
 * 10.9IT — TRILHA DE DIAGNÓSTICO. Thiago: "faz uma auditoria rápida sobre o funcionamento do apk,
 * joga uns logs".
 *
 * Um travamento que só acontece no celular não dá pra reproduzir aqui, e um stack sozinho diz
 * ONDE explodiu, não O QUE o jogador fez antes. Isto é a resposta: um anel de ~200 eventos curtos
 * (estado do jogo, telas abrindo/fechando, app dormindo/acordando, nuvem, login, raid, região,
 * WebGL) que fica no aparelho (`vh_diag`) e viaja JUNTO com o relatório de travamento pra nuvem.
 * No painel /admin o travamento aparece com os últimos 40 passos antes dele.
 *
 * Barato de propósito: string curta por evento, gravação agrupada (800 ms), nada por quadro.
 */

interface Ev {
  t: number;
  tag: string;
  d?: string;
}

const MAX = 200;
const KEY = "vh_diag";

function safe(d: unknown): string {
  try {
    return typeof d === "string" ? d : JSON.stringify(d);
  } catch {
    return String(d);
  }
}

function hora(t: number): string {
  const d = new Date(t);
  const p = (n: number, w = 2): string => String(n).padStart(w, "0");
  return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}.${p(d.getMilliseconds(), 3)}`;
}

class Diag {
  private buf: Ev[] = [];
  private dirty = false;
  private timer = 0;

  constructor() {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) {
        const o = JSON.parse(raw) as unknown;
        if (Array.isArray(o)) this.buf = (o as Ev[]).filter((e) => e && typeof e.t === "number" && typeof e.tag === "string").slice(-MAX);
      }
    } catch {
      /* sem storage: só memória */
    }
    this.log("sessao", "inicio");
  }

  log(tag: string, d?: unknown): void {
    const s = d === undefined ? undefined : safe(d).slice(0, 200);
    this.buf.push({ t: Date.now(), tag, d: s });
    if (this.buf.length > MAX) this.buf.splice(0, this.buf.length - MAX);
    if (import.meta.env.DEV) console.debug(`[diag] ${tag}`, s ?? "");
    this.dirty = true;
    if (!this.timer) this.timer = window.setTimeout(() => this.flush(), 800);
  }

  flush(): void {
    this.timer = 0;
    if (!this.dirty) return;
    this.dirty = false;
    try {
      localStorage.setItem(KEY, JSON.stringify(this.buf));
    } catch {
      /* cheio: paciência */
    }
  }

  /** Últimos `n` eventos em texto, um por linha (vai no relatório de travamento). */
  trail(n = 40): string {
    return this.buf
      .slice(-n)
      .map((e) => `${hora(e.t)} ${e.tag}${e.d ? " " + e.d : ""}`)
      .join("\n");
  }
}

export const diag = new Diag();
